import type React from 'react';

import styles from './styles';

import { colors, fonts } from '../../styles';

type TextAnchor = 'middle' | 'end';

export interface ChartTickLabelProps {
  x: number;
  y: number;
  dx?: number;
  dy?: number;
  value: number;
  formatter?: (value: any) => string;
  textAnchor?: TextAnchor;
  fontWeight?: number;
  enableBackground?: boolean;
  backGroundWidth?: string;
  annotation?: boolean;
  onAnnotationMouseEnter?: (infoX: number, infoY: number, label: number) => void;
  onAnnotationMouseLeave?: () => void;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const ChartTickLabel: React.FC<ChartTickLabelProps> = ({
  x,
  dx,
  y,
  dy,
  value,
  formatter,
  textAnchor,
  fontWeight,
  enableBackground,
  backGroundWidth,
  annotation = false,
  onAnnotationMouseEnter,
  onAnnotationMouseLeave,
}) => {
  const handleOnAnnotationMouseEnter = () => {
    if (onAnnotationMouseEnter) {
      onAnnotationMouseEnter(x, y, value);
    }
  };

  const handleOnAnnotationMouseLeave = () => {
    if (onAnnotationMouseLeave) {
      onAnnotationMouseLeave();
    }
  };

  return (
    <g>
      {enableBackground && backGroundWidth && <rect x={x} y={y - 20 + (dy || 0)} fill={colors.shadows.getShadow(colors.white, 0.85)} width={backGroundWidth} height='30px' />}

      {annotation && (
        <g
          onMouseEnter={handleOnAnnotationMouseEnter}
          onMouseLeave={handleOnAnnotationMouseLeave}
          className={styles.annotationIcon}
          width='17'
          height='17'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect x={x - 9} y={y + 10 + (dy || 0)} width='16.3' height='16.3' rx='1.65' stroke='#9DA9B6' strokeWidth='0.7' />
          <text x={x - 4.5} y={y + 23 + (dy || 0)} fill='#9DA9B6'>
            1
          </text>
        </g>
      )}

      <text
        x={x}
        y={y}
        dx={dx || 0}
        dy={dy || 0}
        textAnchor={textAnchor || 'middle'}
        fill={colors.gray.dark}
        fontSize={fonts.size.small}
        fontWeight={fontWeight || fonts.weight.regular}
      >
        {formatter ? formatter(value) : value}
      </text>
    </g>
  );
};
